export default __webpack_public_path__ + "static/media/25.b9670075.png";